import { API_LOCATION_URL } from 'infrastructure/config';
import { getCookie } from 'utils/cookie';
import {
    IPostInput,
    IPostResponse,
    IBuyerLoginByEmailClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerLoginByEmailClient';

const PATH = `${API_LOCATION_URL}/buyer/user/login`;
const csrfToken = getCookie('csrftoken');

export class BuyerLoginByEmailClient implements IBuyerLoginByEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email, password } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        const body = JSON.stringify({
            email,
            password,
        });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
